import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import AuditLog from '../../entities/admin/auditlog'
import Ajax from '../../../lib/ajax' 
import Util from '../../../lib/util'

interface AuditLogState extends ListState<AuditLog>{
    editModel:AuditLog;
    dates: Array<any>;    
}
class AuditLogModule extends ListModule<AuditLogState,any,AuditLog>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<AuditLog>(),
        loading:false,
        editModel: new AuditLog(),
        activeList: new Array<AuditLog>(),
        dates: new Array<any>(),
        path: 'audit-logs'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions    
        async getDatesByMonth(context: ActionContext<AuditLogState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/audit-logs-dates', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.dates = reponse.data.result;
            context.state.loading = false;
        },    
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        setDates(state: AuditLogState, list: any) {
            if (list == null) list = [];
            state.dates = list;
        }
    });
}
const branchModule=new AuditLogModule();
export default branchModule;
